import { render, staticRenderFns } from "./perfilComponent.vue?vue&type=template&id=76c35a88"
import script from "./perfilComponent.vue?vue&type=script&lang=js"
export * from "./perfilComponent.vue?vue&type=script&lang=js"
import style0 from "./perfilComponent.vue?vue&type=style&index=0&id=76c35a88&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports